export default function checkGarageStatus() {
	let garageInfoContent = document.querySelector('.garage-info__content');

	if (!garageInfoContent) {
		return;
	}
	// Map days in French to the weekday index (0 = Sunday, 6 = Saturday)
	let daysMap = {
		Lundi: 1,
		Mardi: 2,
		Mercredi: 3,
		Jeudi: 4,
		Vendredi: 5,
		Samedi: 6,
		Dimanche: 0,
	};

	if(document.body.getAttribute('data-lang-slug') === 'nl') {
		daysMap = {
			Zondag: 0,
			Maandag: 1,
			Dinsdag: 2,
			Woensdag: 3,
			Donderdag: 4,
			Vrijdag: 5,
			Zaterdag: 6,
		};
	}

	// Get current date and time in Brussels timezone
	const now = new Date();
	const brusselsTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Brussels' }));
	const currentDayIndex = brusselsTime.getDay();
	const currentTime = brusselsTime.toTimeString().slice(0, 5); // Format as "HH:mm"

	// Find the current day in French based on the HTML
	const currentDayName = Object.keys(daysMap).find((day) => daysMap[day] === currentDayIndex);

	// Select the garage hours section for the current day
	const hoursElements = document.querySelectorAll(`.garage-info__hours-item`);
	let isOpen = false;

	hoursElements.forEach((element) => {
		const dayElement = element.querySelector('.garage-info__hours-day');
		const timeElement = element.querySelector('.garage-info__hours-time');

		if (!dayElement || !timeElement) {
			return; // Skip this element if either dayElement or timeElement doesn't exist
		}

		// // Only log if dayElement has content
		// if (dayElement.textContent) {
		// 	console.log(dayElement.textContent.trim());
		// }

		if (dayElement.textContent && dayElement.textContent.trim() === currentDayName) {
			const hours = timeElement.textContent.split(', ');

			console.log(currentTime);

			for (let period of hours) {
				const trimmedPeriod = period.trim();
				// Check if period starts with a digit, indicating it has opening hours
				if (!/^\d/.test(trimmedPeriod)) {
					continue; // Skip this period but don't override isOpen status
				}

				const [start, end] = trimmedPeriod.split(' - ');

				console.log(start, end);

				// Only compare if both start and end times are present
				if (start && end) {
					if (currentTime >= start && currentTime <= end) {
						isOpen = true;
						break;
					}
				}
			}
		}
	});

	// Update the status display
	const statusElement = document.querySelector('.c-qt-contact__open');
	if (statusElement) {
		// Make sure menaObject exists before using it
		if (typeof menaObject !== 'undefined' && menaObject.labels && menaObject.labels.garage_locator) {
			statusElement.textContent = isOpen ? menaObject.labels.garage_locator.open : menaObject.labels.garage_locator.closed;
			statusElement.classList.toggle('c-qt-contact__open--closed', !isOpen);
		} else {
			// Fallback if menaObject is not available
			statusElement.textContent = isOpen ? 'Open' : 'Closed';
			statusElement.classList.toggle('c-qt-contact__open--closed', !isOpen);
		}
	}
}
